import React from 'react';
import { MnLoading } from '../../../index';
import { Layout } from '../organisms/index';
import ReactMarkdown from 'react-markdown/with-html';

export default class SpecifiedCommercialTransactionsLawShow extends React.Component {
  text = `
### 提供事業者の名称
株式会社メディカルノート

### 住所
東京都港区東新橋二丁目3番3号 ルオーゴ汐留 5F

### 電話番号
03-4500-9450

※サービスに関わるお問い合わせは、お問い合わせメールアドレス宛にお願いいたします

※医療に関わる相談は電話では受け付けておりません

### 代表者
小林 裕貴

### 発信元メールアドレス
support(at)medicalnote-qa.jp

### サービスの価格
クレジットカードによるお支払いまたは携帯電話会社の代金回収のうち、お客様が選択された支払い手段により異なりますので、詳しくは各クレジットカード会社または各携帯電話会社、決済代行サービス提供会社に直接お問い合わせください。

### サービスの対価 およびサービスの対価以外に必要な費用（送料、手数料、消費税等）
サイトの閲覧、コンテンツのダウンロード、お問い合わせ等の際の電子メールの送受信時などに、所定の通信料が発生いたします（金額は、お客様が契約した各事業者が定める通り）。

### 引渡時期
当社所定の手続き終了後、直ちにご利用いただけます。

### 返品
サービスとしての性質上、返品／キャンセルには応じられません。
`;

  render () {
    return (<React.Suspense fallback={ <MnLoading/> }>
      <Layout state={this.props}>
        <div className="p-container p-menus">
          <div className="l-conatiner">
            <h4 className="w90p c-mn-title-2 ta-c">特定商取引法に基づく<br/>表示</h4>
            <div className="p-container--content p-container--md">
              <ReactMarkdown source={this.text} escapeHtml={true}/>
            </div>
          </div>
        </div>
      </Layout>
    </React.Suspense>);
  }
}
